import styled from 'styled-components'
import { secondaryForSite } from '../../../theme/colors';

export function makeMobileNav (element) {
  return styled(element)`
    #mobile-nav-links {
      overflow: hidden;
      position: relative;
      text-align: center;
      justify-content: start;
      width: 100%;
      height: 0px;
      transition: height 300ms ease;
      background: #024f4b;
      
      &.open {
        display: block;
        .mobile-menu-bounding-box {
          height: 575px;
        }
        height: 650px;
        transition: height 300ms ease;
      }
    }
  `
}

export default makeMobileNav